<template>
  <router-view />
</template>

<script>
export default {
  name: "AgenciesIndex",
};
</script>
